import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { BusinessRulesInterface } from '../interfaces/business-rules.interface';

@Injectable()
export class BusinessRulesService {
  private readonly url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.BUSINESS_RULES_API_URL}`;
  }

  fetchAll(query: any): Observable<BusinessRulesInterface[]> {
    const queryParams = new HttpParams().set('filter', JSON.stringify(query));
    return this.http.get<BusinessRulesInterface[]>(this.url, { params: queryParams });
  }

  create(businessRule: BusinessRulesInterface): Observable<BusinessRulesInterface> {
    return this.http.post<BusinessRulesInterface>(this.url, businessRule);
  }

  update(businessRule: BusinessRulesInterface, id: string): Observable<BusinessRulesInterface> {
    return this.http.put<BusinessRulesInterface>(`${this.url}/${id}`, businessRule);
  }

  delete(id: string): Observable<BusinessRulesInterface> {
    return this.http.delete<BusinessRulesInterface>(`${this.url}/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/business-rules.service.ts